import React, { useContext, useEffect } from 'react';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { MenuAttributeProps, MenuAttributeTypes } from '../../modal/MenuAttribute';
import FormModal from '../../modal/FormModal';
import { ClientContact } from './ClientContactTable';
import { UserSessionDetails, UserSessionDetailsContext } from '../../App';

const queryClient = new QueryClient()

interface ClientContactUpdateModalProps {
    refreshTable: () => void;
    isOpen: boolean;
    closeModal: () => void;
    data: ClientContact;
}

const ClientContactUpdateModal = (props: ClientContactUpdateModalProps): JSX.Element => (
    <QueryClientProvider client={queryClient}>
        <ClientContactAddModalInner {...props}/>
    </QueryClientProvider>
)

const ClientContactAddModalInner = (props: ClientContactUpdateModalProps): JSX.Element => {
    const sessionDetails: UserSessionDetails = useContext(UserSessionDetailsContext);
    const [nameValue, setNameValue] = React.useState("");
    const [phoneValue, setPhoneValue] = React.useState("");
    const [addressValue, setAddressValue] = React.useState("");
    const [emailValue, setEmailValue] = React.useState("");
    useEffect(() => {
        setNameValue(props.data.name);
        setPhoneValue(props.data.phone);
        setAddressValue(props.data.address);
        setEmailValue(props.data.email);
    }, [props.data]);

    const menuAttributes: MenuAttributeProps[] = [
        {
            name: "Name",
            attributeType: MenuAttributeTypes.short_input,
            set_value: nameValue,
            setValue: setNameValue
        },
        {
            name: "Phone",
            attributeType: MenuAttributeTypes.short_input,
            set_value: phoneValue,
            setValue: setPhoneValue
        },
        {
            name: "Address",
            attributeType: MenuAttributeTypes.short_input,
            set_value: addressValue,
            setValue: setAddressValue
        },
        {
            name: "Email",
            attributeType: MenuAttributeTypes.short_input,
            set_value: emailValue,
            setValue: setEmailValue
        }
    ];

    // disabled if there exists a form element w/ length 0
    const isSaveButtonDisabled = (): boolean => 
        [nameValue, phoneValue, addressValue, emailValue].find((el: string) => el.length === 0) !== undefined;
    
    // submit request stuff
    const { data, status, refetch, remove } = useQuery('client_add', async () => {
        const res = await fetch(`${sessionDetails.backend.host}:${sessionDetails.backend.port}/client_contact`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                access_token: sessionDetails.access_token,
                req: {
                    id: props.data.id,
                    client_id: props.data.client_id,
                    name: nameValue,
                    phone: phoneValue,
                    address: addressValue,
                    email: emailValue 
                }
            })
        });
        return res.json();
    }, { // options are here so it won't auto-fetch
        refetchOnWindowFocus: false,
        enabled: false, 
    });
    const loading = status !== 'success' || data.STATUS !== 'SUCCESS';

    const onSubmit = () => {
        refetch();
    }

    useEffect(() => {
        if (!loading) {
            remove();
            props.closeModal();
            props.refreshTable();
        }
    }, [loading, props, remove]);
    
    return (
        <FormModal 
            title='Update Client Contact'
            form_strategy='Update'
            menuAttributes={menuAttributes}
            onClose={props.closeModal}
            isOpen={props.isOpen}
            isSaveButtonDisabled={isSaveButtonDisabled}
            onSave={onSubmit}
        />
    )
};

export default ClientContactUpdateModal